import { render, staticRenderFns } from "./AddFeatureModal.vue?vue&type=template&id=bc389a48&scoped=true&"
import script from "./AddFeatureModal.vue?vue&type=script&lang=js&"
export * from "./AddFeatureModal.vue?vue&type=script&lang=js&"
import style0 from "./AddFeatureModal.vue?vue&type=style&index=0&id=bc389a48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc389a48",
  null
  
)

export default component.exports